const refrigeratorRepairService = {
  title: "Refrigerator Repair",
  icon: "🧊",
  rateCardKey: "refrigerator",
  shortDescription:
    "Cooling checks, gas suspicion, door issues, water leakage, and refrigerator repair support.",
  longDescription:
    "Book refrigerator support for cooling issues, unusual noise, door gasket issues, leakage, and standard appliance repair checks.",
  consultationNote:
    "Gas charging, compressor issues, PCB faults, and deeper cooling failures require inspection first.",
  responsePromise:
    "Assignment depends on refrigerator type, model, and issue complexity.",
  warrantyPolicy:
    "Support depends on appliance age, spare part use, and actual repair scope.",
  subServices: [
    {
      id: "fridge-inspection",
      title: "Cooling / Performance Inspection",
      icon: "🌡️",
      group: "Inspection",
      description:
        "Inspection for not cooling, overcooling, noise, or freezer section imbalance.",
      basePrice: 249,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "fridge-door-gasket",
      title: "Door / Gasket Issue",
      icon: "🚪",
      group: "Repair",
      description:
        "Check and minor support for sealing issue, door alignment, or loose closure problem.",
      basePrice: 349,
      priceType: "starts_at",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "fridge-water-leakage",
      title: "Water Leakage Check",
      icon: "💧",
      group: "Repair",
      description:
        "Inspection and basic support for internal leakage or outlet blockage symptoms.",
      basePrice: 349,
      priceType: "starts_at",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "fridge-installation",
      title: "Refrigerator Installation / Setup",
      icon: "🧰",
      group: "Installation",
      description:
        "Basic setup and positioning support for new or shifted refrigerator unit.",
      basePrice: 399,
      priceType: "fixed",
      duration: "20-40 mins",
      warranty: "Visit completion only",
      unit: "job",
    },
  ],
};

export default refrigeratorRepairService;